import type { ContentNode, DataTypeLocator } from '@helo/cms'
import { ManualContentHelpers, processRuntimeConfig } from '@helo/cms'

import {
  EMPTY_VALUE_DEFAULT,
  MULTIPLE,
  valueTransformer,
} from '../../../utils/valueFormatter'

/**
 * Resolves the primary **entity display string** for the current detail screen
 * (e.g. purchase order id, item id, shipment id, container id) — the same
 * formatted scalar as the page heading/back link, for use in `document.title`.
 */
export const deriveDetailEntityDisplayString = (
  queryId: string,
  selector: DataTypeLocator | undefined,
  query: (id: string) => unknown,
): string | null => {
  try {
    const processed = processRuntimeConfig(
      ManualContentHelpers.setState(
        ManualContentHelpers.createContentNodeReference(
          queryId,
          selector ?? [],
        ),
        { linkUrl: false },
      ),
      { query },
    ) as ContentNode | null

    if (!processed || typeof processed !== 'object' || !('data' in processed)) {
      return null
    }

    const raw = valueTransformer((processed as { data: unknown }).data)
    const trimmed = raw?.trim()
    if (!trimmed || trimmed === EMPTY_VALUE_DEFAULT || trimmed === MULTIPLE) {
      return null
    }
    return trimmed
  } catch {
    return null
  }
}
